import { Command } from '@/app/tracking/api';

export const StartCourseCommandName = 'start-course' as const;
export type StartCourseCommand =
      Command<typeof StartCourseCommandName, {}>;
